import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { migrationService } from '../api/migration.service';

const DETAIL_STALE_MS = 5 * 60 * 1000;

export function useMigrationLegacyClientQuery(partnerId: string | null) {
  return useQuery({
    queryKey: queryKeys.migration.legacyClient(partnerId ?? ''),
    queryFn: () => migrationService.getLegacyClient(partnerId!),
    enabled: Boolean(partnerId),
    staleTime: DETAIL_STALE_MS,
  });
}
